import axios from 'axios';

import { clearSessionProfile } from './helpers';

let sessionExpiredHandler = null;

export const registerSessionExpiredHandler = handler => {
    sessionExpiredHandler = handler;
};

export const axiosInstance = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_BACKEND_URL,
});

const isAuthEndpoint = url => url?.includes('/user/login') || url?.includes('/user/logout');

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        const status = error.response?.status;
        const requestUrl = error.config?.url;

        if (status === 401 && !isAuthEndpoint(requestUrl)) {
            clearSessionProfile();
            sessionExpiredHandler?.();
        }

        return Promise.reject(error);
    }
);

export const cancelToken = axios.CancelToken;
export const cancelHttpReq = cancelToken.source();
